module.exports = __webpack_public_path__ + "media/images/the-prize-title-4e286bffd5522c7982a45e42fe7b41d6.svg";